import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

let router = new Router({
    mode: 'hash',
    // stringifyQuery: query => {
    //     if (!Object.keys(query).length) {
    //         return ""
    //     }
    //
    //     let result = "";
    //     Object.entries(query).forEach(x => {
    //         result += `${x[0]}=${x[1]}&`
    //     });
    //     result = result.slice(0, -1);
    //     return result ? ('?' + result) : ''
    // },
    routes: [
        {
            path: '/',
            name: 'search',
            meta: { title: "tourProgramVariantsSearch"},
            component: () => import('./views/tour/navbar.vue'),
            children: [
                {
                    path: "/:searchParams",
                    name: "home_searched",
                    meta: { title: "tourProgramVariantsSearch" },
                    component: () => import('./views/tour/navbar.vue'),
                }
            ]
        },
        {
            path: '/Individuals/Hotels',
            name: 'hotels',
            meta: { title: "hotelsVariantsSearch"},
            component: () => import('./views/tour/navbar.vue'),
        },
        {
            path: '/Individuals/Hotels/:searchParams',
            name: "hotels_searched",
            meta: { title: "hotelsVariantsSearch" },
            component: () => import('./views/tour/navbar.vue'),
        },
        {
            path: '/Individuals/Avia',
            name: 'tickets',
            meta: { title: "searchFlightTickets"},
            component: () => import('./views/tour/navbar.vue'),
        },
        {
            path: '/Individuals/Avia/:searchParams',
            name: "tickets_searched",
            meta: { title: "searchFlightTickets" },
            component: () => import('./views/tour/navbar.vue'),
        },
        {
            path: '/Individuals/Quotes',
            name: 'quotes',
            meta: { title: "quotasVariantsSearch"},
            component: () => import('./views/tour/navbar.vue'),
        },
        {
            path: '/Individuals/Quotes/:searchParams',
            name: "quotes_searched",
            meta: { title: "quotasVariantsSearch" },
            component: () => import('./views/tour/navbar.vue'),
        }
    ]
});

export default router;
